module.exports = __webpack_public_path__ + "static/tangiers-casino-f110b23222c5401594e1849df87289a6.png";